// extracted by mini-css-extract-plugin
module.exports = {"error":"error404_error__-1MQa"};